import React from 'react';

const ServiceCard = ({ variant, title, children, buttonText, linkUrl }) => {
  return (
    <div className={`service-card-container card-variant-${variant}`}>
      <div className="service-card">
        
        {/* TITRE TEXTE */}
        <div className="card-logo">
          NEWCO <span style={{fontSize: '0.8em'}}>{title}</span>
        </div>

        <div className="card-text">
          {children}
        </div>
        
        <a 
          href={linkUrl} 
          target="_blank" 
          rel="noopener noreferrer" 
          className="card-btn"
        >
          {buttonText}
        </a>
        
      </div>
    </div>
  );
};

export default ServiceCard;